import React from 'react';

import MissionControlBoard from './MissionControlBoard/MissionControlBoard';

import MissionControlMap from './MissionControlMap/MissionControlMap';

import classes from './MissionControl.module.scss';
import MissionControlHead from './MissionControlHead/MissionControlHead';
import { IGetChargingPointResponse } from 'models/http/chargingPoint';
import { OnChangeValue } from 'react-select';
import { MSelectChangeData, MSelectOption } from 'views/MSelect/MSelect.model';
import { ConnectorPowerLabel, ConnectorTypeLabel } from 'utils/enums/chargingType';
import { LayersTypes } from 'components/MapLayers/MapLayers.model';
import MapLayers from 'components/MapLayers/MapLayers';
import moment from 'moment';

type Props = {
  showLayerType: LayersTypes | null;
  dateFilters: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  };
  generalFilterValue: string;
  chargingPoints?: IGetChargingPointResponse['records'];
  powerTypeFilters: MSelectOption<null, ConnectorPowerLabel>[];
  connectorTypeFilters: MSelectOption<null, ConnectorTypeLabel>[];
  onClickLayer: (layer: LayersTypes | null) => void;

  onDateFilterChange: (startDate: moment.Moment | null, endDate: moment.Moment | null) => void;
  onResetDate?: () => void;
  onGeneralFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearGeneralFilter: () => void;
  onPowerTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorPowerLabel>, true>) => void;
  onConnectorTypeFilterChange: (value: OnChangeValue<MSelectChangeData<null, ConnectorTypeLabel>, true>) => void;
};

const MissionControlView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <div className={classes['body']}>
        <MissionControlHead
          connectorTypeFilters={props.connectorTypeFilters}
          onConnectorTypeFilterChange={props.onConnectorTypeFilterChange}
          onGeneralFilterChange={props.onGeneralFilterChange}
          generalFilterValue={props.generalFilterValue}
          onResetDate={props.onResetDate}
          dateFilters={props.dateFilters}
          onDateFilterChange={props.onDateFilterChange}
          onClearGeneralFilter={props.onClearGeneralFilter}
          onPowerTypeFilterChange={props.onPowerTypeFilterChange}
          powerTypeFilters={props.powerTypeFilters}
        ></MissionControlHead>

        {props.showLayerType !== LayersTypes.EV ? <MissionControlBoard></MissionControlBoard> : null}
      </div>
      <div className={classes['footer']}>
        <MapLayers showLayerType={props.showLayerType} onClickLayer={props.onClickLayer}></MapLayers>
      </div>

      <MissionControlMap chargingPoints={props.chargingPoints || []} showLayerType={props.showLayerType}></MissionControlMap>
    </div>
  );
};

MissionControlView.displayName = 'MissionControlView';

export default MissionControlView;
